module.exports = __webpack_public_path__ + "images/terms_of_use.pdf?v=f063cf09e77efca0fe03ba40ffa9b654";